import { useIsMobile } from "../hooks/useIsMobile";

const PERMISSIONS = {
  CALL: {
    mobile: 2,
    desktop: 0
  },
  WHATSAPP: {
    mobile: 3,
    desktop: 1
  }
};

const hasPermission = (user, type, isMobile) =>
  user.allowed?.charAt(
    isMobile
      ? PERMISSIONS[type].mobile
      : PERMISSIONS[type].desktop
  ) === "1";

export const ContactButton = ({
  type,          // "CALL" | "WHATSAPP"
  user,
  rowData,
  onAction
}) => {
  const isMobile = useIsMobile();

  const employee = rowData.find(x => x.name === user.name);
  if (!employee) return null;

  if (!hasPermission(user, type, isMobile)) return null;

  const config = {
    CALL: {
      id: "Empoyee_Dashi_Mobtelephone",
      icon: "Call_Connected.png",
      alt: "Call Candidate",
      handler: showId =>
        onAction(showId, employee.name)
    },
    WHATSAPP: {
      id: "Empoyee_Dashi_Mobwhatsapp_dashboard",
      icon: "whatsappdashboard.png",
      alt: "WhatsApp Candidate",
      handler: showId =>
        onAction(showId, employee.name)
    }
  }[type];

  const targetId = employee.currentCandidate
    ? employee.interviewid
    : "new";

  return (
    <img
      id={config.id}
      src={config.icon}
      srcSet={
        type === "WHATSAPP"
          ? "whatsappdashboard.png 1x, whatsappdashboard@2x.png 2x"
          : undefined
      }
      alt={config.alt}
      onClick={() => config.handler(targetId)}
    />
  );
};
